import React from "react";
import { X } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import { T, tr } from "../lib/i18n";

export function QRDialog({ open, onOpenChange, lang, restaurant }) {
  const url = typeof window !== "undefined" ? window.location.href : "";
  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=280x280&margin=8&color=1c1917&data=${encodeURIComponent(url)}`;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-sm p-0 gap-0 overflow-hidden">
        <div className="flex items-center justify-between px-5 py-4 border-b border-neutral-100">
          <DialogTitle className="font-serif text-lg font-semibold">{restaurant?.name || "Menu"}</DialogTitle>
          <button onClick={() => onOpenChange(false)} className="h-8 w-8 rounded-full hover:bg-neutral-100 flex items-center justify-center">
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="p-6 flex flex-col items-center text-center">
          <div className="rounded-2xl bg-white ring-1 ring-neutral-200 p-3 shadow-sm">
            <img src={qrUrl} alt="QR menu" className="h-64 w-64" />
          </div>
          <p className="mt-4 text-sm text-neutral-600 max-w-xs">{tr(T.scanQr, lang)}</p>
          <p className="mt-3 text-xs text-neutral-400 break-all px-2">{url}</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
